import React from "react";
import { Card } from "antd";

import RankPanel from "./RankPanel";
import NamePlate from "./NamePlate";

import { replaceCodeWithHiragana } from "./HiraganaKeyboard/hiragana";

const ProfilePreview = ({ currentPlayer, userData }) => {
    let profileDataKey;

    if (currentPlayer === 1) {
        profileDataKey = "profile_p1";
    } else {
        profileDataKey = "profile_p2";
    }

    return (
        <Card title="Preview">
            <div
                style={{
                    display: `flex`,
                    flexDirection: `column`,
                    alignItems: `center`,
                    justifyContent: `center`,
                }}
            >
                <RankPanel currentPlayer={currentPlayer} userData={userData} />

                <NamePlate
                    player={currentPlayer}
                    name={replaceCodeWithHiragana(
                        userData[profileDataKey].userName
                    )}
                    title={userData[profileDataKey].userTitle}
                    shougouBaseId={
                        userData[profileDataKey].userTitleShougouBase
                    }
                />
            </div>
        </Card>
    );
};

export default ProfilePreview;
